"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEAM_MEMBERSHIP_ROLES = exports.VALIDATION_STATUSES = exports.MARKETING_CONSENT_LEVELS = exports.SUBSCRIPTION_STATUSES = exports.SUBSCRIPTION_TYPES = exports.CHANNEL_TYPES = exports.BRANDS = exports.businessTypeOptions = exports.BUSINESS_TYPES = void 0;
exports.BUSINESS_TYPES = [
    'Construction/Municipal',
    'Contractor',
    'Cooperative',
    'Educational/Research Institute',
    'Farm',
    'Fleet Hire',
    'Forestry',
    'Government/Public Utility',
    'Grounds Care',
    'Horticultural',
    'Industrial',
    'Leisure',
    'Media/Press',
    'Other',
];
exports.businessTypeOptions = {
    floatable: true,
    options: exports.BUSINESS_TYPES.map(function (type) { return ({
        value: type,
        label: type,
    }); }),
};
exports.BRANDS = {
    VALTRA: 'VALTRA',
    MF: 'MF',
    TECNO: 'TECNO',
    CIMBRIA: 'CIMBRIA',
    GSI: 'GSI',
    CHALLENGER: 'CHALLENGER',
    AP: 'AP',
    FENDT: 'FENDT',
    AGCO: 'AGCO',
    CUMBERLAND: 'CUMBERLAND',
    AFTERSALES: 'AFTERSALES',
};
exports.CHANNEL_TYPES = {
    Phone: 'Phone',
    Email: 'Email',
    MailingAddress: 'MailingAddress',
    SMS: 'SMS',
};
exports.SUBSCRIPTION_TYPES = {
    Offers: 'Offers',
    Events: 'Events',
    Merchandise: 'Merchandise',
    News: 'News',
    Newsletter: 'Newsletter',
    Surveys: 'Surveys',
    Parts: 'Parts',
    Promotion: 'Promotion',
};
exports.SUBSCRIPTION_STATUSES = {
    NotSeen: 'Not Seen',
    OptIn: 'Opt In',
    OptOut: 'Opt Out',
    Seen: 'Seen',
};
exports.MARKETING_CONSENT_LEVELS = {
    L1: 'L1',
    L2: 'L2',
    L3: 'L3',
    NOT_SET: 'NOT_SET',
};
exports.VALIDATION_STATUSES = {
    VERIFIED: 'VERIFIED',
    UNVERIFIED: 'UNVERIFIED',
    BUSINESS: 'BUSINESS',
    PERSONAL: 'PERSONAL',
};
exports.TEAM_MEMBERSHIP_ROLES = {
    ASSISTANT: 'ASSISTANT',
    BUYER: 'BUYER',
    DRIVER: 'DRIVER',
    DECISION_MAKER: 'DECISION_MAKER',
    ECONOMIC_DECISION_MAKER: 'ECONOMIC_DECISION_MAKER',
    ECONOMIC_BUYER: 'ECONOMIC_BUYER',
    FLEET_MANAGER: 'FLEET_MANAGER',
    MECHANIC: 'MECHANIC',
    OPERATOR: 'OPERATOR',
    OWNER: 'OWNER',
    OTHER: 'OTHER',
};
